module.exports = __webpack_public_path__ + "img/debtPayingAbility3.39446b55.png";